/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/react-in-jsx-scope */
import React from "react";
import { NON_RKPAY_INVOICE_COLUMNS } from "@constants";
import PropTypes from "prop-types";
import utils from "@utils";
import { ScrollDetect } from "../../../../components";

const EstimatesTable = ({
	updateSort,
	selectAllRecords,
	multipleSelection,
	filters,
	records,
	onEditInvoice,
	selectedRecords,
	updateSelectedRecord,
	user,
	onApplyPayment,
	hasMoreRecords,
	loadNextPage,
	estimateTabAvailablefundsColumn,
	nonrkpayDetailPrepayEnhancements
}) => {
	const { lang } = global;

	const getJobDateValue = (startDateTime, endDateTime) => {
		const sameJobDay = utils.datesAreOnSameDay(new Date(startDateTime), new Date(endDateTime));

		return sameJobDay
			? utils.formatDate(startDateTime, 'en-US', user.TimeZoneId, 'numeric')
			: `${utils.formatDate(startDateTime, 'en-US', user.TimeZoneId, 'numeric')} - ${utils.formatDate(endDateTime, 'en-US', user.TimeZoneId, 'numeric')}`;
	};

	const showCreatedDateColumn = () => !estimateTabAvailablefundsColumn || !nonrkpayDetailPrepayEnhancements
	const showAvailableFundsColumn = () => estimateTabAvailablefundsColumn && nonrkpayDetailPrepayEnhancements;

	return (
		<>
			<div className="row hidden-xs hidden-sm hidden-md invoice-columns">
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber);
					}}
				>
					<If condition={multipleSelection}>
						<label
							htmlFor="checkbox_all"
							className="selector-label margin-right-12"
						>
							<input
								type="checkbox"
								id="checkbox_all"
								name="selectAllItems"
								onChange={() => selectAllRecords()}
								onClick={e => e.stopPropagation()}
								aria-label="Select All Items"
								disabled
							/>
						</label>
					</If>
					<span className="font-semi-bold">{lang.t("Estimate")} #</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.ClientName)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.ClientName);
					}}
				>
					<span className="font-semi-bold">{lang.t("Client")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.ClientName}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<If condition={showCreatedDateColumn()}>
					<div
						className="col-md-2 col-lg-1 date-range-column"
						role="button"
						tabIndex={0}
						onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.IssueDate)}
						onKeyPress={({ key }) => {
							if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.IssueDate);
						}}
					>
						<span className="font-semi-bold">{lang.t("Created Date")}</span>
						<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.IssueDate}>
							<i
								className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
							/>
						</If>
					</div>
				</If>
				<div
					className="col-md-2 col-lg-1"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.SentDate)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.SentDate);
					}}
				>
					<span className="font-semi-bold">{lang.t("Sent Date")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.SentDate}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-1 date-range-column"
					role="button"
					tabIndex={0}
				>
					<span className="font-semi-bold">{lang.t("Job Date")}</span>
				</div>
				<div
					className="col-md-1 col-lg-1 text-right"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.Total)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.Total);
					}}
				>
					<span className="font-semi-bold">{lang.t("Total")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.Total}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2 text-right"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.Balance)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.Balance);
					}}
				>
					<span className="font-semi-bold">{lang.t("Balance")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.Balance}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<If condition={showAvailableFundsColumn()}>
					<div className="col-md-1 col-lg-1 text-right">
						<span className="font-semi-bold">{lang.t("Available Funds")}</span>
					</div>
				</If>
				<div className="col-md-2 col-lg-2 hidden-xs hidden-md" />
			</div>
			<div className="hidden-xs hidden-sm hidden-md invoice-columns-body">
				{records.length > 0 &&
					records.map(item => (
						<div
							key={`${item.Id}-${item.InvoiceNumber}`}
							className="row"
							role="button"
							onClick={onEditInvoice(item.Id)}
							tabIndex={0}
						>
							<div className="col-md-2 col-lg-2 truncate">
								<If condition={multipleSelection}>
									<label
										htmlFor={`check_${item.Id}`}
										className="selector-label margin-right-12"
									>
										<input
											type="checkbox"
											id={`check_${item.Id}`}
											name="selectItem"
											checked={selectedRecords[item.Id]}
											onChange={() => updateSelectedRecord(item)}
											onClick={e => e.stopPropagation()}
											aria-label="Select Item"
											disabled
										/>
									</label>
								</If>
								<span>{item.InvoiceNumber}</span>
							</div>
							<div
								className="col-md-2 col-lg-2 truncate"
								title={item.ClientName}
							>
								<span>{item.ClientName}</span>
							</div>
							<If condition={showCreatedDateColumn()}>
								<div className="col-md-2 col-lg-1 date-range-column">
									<span>
										{utils.formatDate(
											new Date(item.IssueDate),
											"en-US",
											undefined,
											"2-digit",
										)}
									</span>
								</div>
							</If>
							<div className="col-md-2 col-lg-1">
								<span>
									{item.SentDate == null
										? ""
										: utils.formatDate(
											item.SentDate,
											"en-US",
											user.TimeZoneId,
											"numeric",
										)}
								</span>
							</div>
							<div className="col-md-2 col-lg-1 date-range-column">
								<span>
									{getJobDateValue(item.StartDateTime, item.EndDateTime)}
								</span>
							</div>
							<div className="col-md-1 col-lg-1 text-right">
								<span className="font-semi-bold">
									{utils.currencyFormatter(item.GrandTotal)}
								</span>
							</div>
							<div className="col-md-2 col-lg-2 text-right prepay-column">
								<div className="prepay-badge-container">
									<If condition={item.IsPrepaid}>
										<div
											className="prepay-badge"
											title={lang.t("Prepay")}
										/>
									</If>
								</div>
								<span className="font-semi-bold">
									{utils.currencyFormatter(utils.bankersRound(item.Balance))}
								</span>
							</div>
							<If condition={showAvailableFundsColumn()}>
								<div className="col-md-1 col-lg-1 text-right">
									<span className="font-semi-bold">
										{utils.currencyFormatter(utils.bankersRound(item.AvailableFunds))}
									</span>
								</div>
							</If>
								<div className="col-md-2 col-lg-2 flex flex-justify-content-center flex-gap-8">
									<If condition={!item.EstimateFinalized && !item.Voided} >
										<button
											type="button"
											className="btn btn-primary"
											onClick={onEditInvoice(item.Id)}
											data-prevent-navigation
										>
												<i
													className="rkf rkf-pencil"
													aria-label="edit invoice"
												/>
										</button>
										<button
											type="button"
											className="btn btn-primary btn-block grow"
											onClick={onApplyPayment(item.Id)}
											data-prevent-navigation
											disabled={item.Archived}
										>
											{lang.t("Payments")}
										</button>
									</If>
									<If condition={item.EstimateFinalized || item.Voided} >
										<button
											type="button"
											className="btn btn-primary btn-block grow"
											onClick={onEditInvoice(item.Id)}
											data-prevent-navigation
										>
											{lang.t("View")}
										</button>
									</If>
								</div>
						</div>
					))}
			</div>
			<div className="hidden-lg">
				{records.length > 0 &&
					records.map(item => (
						<div key={`${item.Id}-${item.InvoiceNumber}`} className="row">
							<div className="invoice-card">
								<div className="card-item">
									<If condition={item.IsPrepaid}>
										<div
											className="prepay-badge"
											title={lang.t("Prepay")}
										/>
									</If>
								</div>
								<div className="card-item">
									<span className="font-semi-bold">
										{lang.t("Estimate")} #:&nbsp;
									</span>
									<button
										className="btn btn-link"
										type="button"
										onClick={onEditInvoice(item.Id)}
									>
										{item.InvoiceNumber}
									</button>
								</div>
								<div className="card-item">
									<span className="font-semi-bold">
										{lang.t("Client")}:&nbsp;
									</span>
									<span>{item.ClientName}</span>
								</div>
								<If condition={showCreatedDateColumn()}>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Created Date")}:&nbsp;
										</span>
										<span>
											{utils.formatDate(
												new Date(item.IssueDate),
												"en-US",
												undefined,
												"2-digit",
											)}
										</span>
									</div>
								</If>
								<div className="card-item">
									<span className="font-semi-bold">
										{lang.t("Sent Date")}:&nbsp;
									</span>
									<span>
										{item.SentDate == null
											? ""
											: utils.formatDate(
												item.SentDate,
												"en-US",
												user.TimeZoneId,
												"numeric",
											)}
									</span>
								</div>
								<div className="card-item">
									<span className="font-semi-bold">
										{lang.t("Job Date")}:&nbsp;
									</span>
									<span>
										{getJobDateValue(item.StartDateTime, item.EndDateTime)}
									</span>
								</div>
								<div className="card-item">
									<span className="font-semi-bold">{lang.t("Total")}:&nbsp;</span>
									<span>
										{utils.currencyFormatter(item.GrandTotal)}
									</span>
								</div>
								<div className="card-item">
									<span className="font-semi-bold">
										{lang.t("Balance")}:&nbsp;
									</span>
									<span>
										{utils.currencyFormatter(utils.bankersRound(item.Balance))}
									</span>
								</div>
								<If condition={showAvailableFundsColumn()}>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Available Funds")}:&nbsp;
										</span>
										<span>
											{utils.currencyFormatter(utils.bankersRound(item.AvailableFunds))}
										</span>
									</div>
								</If>
								<div className="actions">
									<If condition={item.EstimateFinalized} >
										<button
											type="button"
											className="btn btn-primary grow"
											onClick={onEditInvoice(item.Id)}
											data-prevent-navigation
										>
											{lang.t("View")}
										</button>
									</If>
									<If condition={!item.EstimateFinalized} >
										<button
											type="button"
											className="btn btn-primary"
											onClick={onEditInvoice(item.Id)}
											data-prevent-navigation
										>
											<i
												className="rkf rkf-pencil"
												aria-label="edit invoice"
											/>
										</button>
										<button
											type="button"
											className="btn btn-primary grow"
											onClick={onApplyPayment(item.Id)}
											data-prevent-navigation
											disabled={item.Archived}
										>
											{lang.t("Payments")}
										</button>
									</If>
								</div>
							</div>
						</div>
					))}
			</div>
			<If condition={hasMoreRecords}>
				<ScrollDetect
					className="text-center"
					onVisible={() => loadNextPage()}
				>
					<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
				</ScrollDetect>
			</If>
		</>
	);
};

EstimatesTable.propTypes = {
	updateSort: PropTypes.func,
	selectAllRecords: PropTypes.func,
	multipleSelection: PropTypes.bool,
	filters: PropTypes.object,
	records: PropTypes.array,
	onEditInvoice: PropTypes.func,
	selectedRecords: PropTypes.object,
	updateSelectedRecord: PropTypes.func,
	user: PropTypes.object,
	onApplyPayment: PropTypes.func,
	hasMoreRecords: PropTypes.bool,
	loadNextPage: PropTypes.func,
	estimateTabAvailablefundsColumn: PropTypes.bool,
	nonrkpayDetailPrepayEnhancements: PropTypes.bool
};

export default EstimatesTable;
